
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";

import { Form, Input , Radio } from 'antd';
import { Assets } from '../../../../assets/Assets'
import { allergentOptions,EmergencyLevel, Actionstotake } from '../../Constants/Menus/ConstantMenus'
import { Nurseactiontaken, getpatientvitals } from '../../../../actions/RPMAction'
import Dropdown from '../DropDown/Dropdown'
import SuccessModal from "../Modals/SuccessModel/SuccessModal";
import './sendambulance.css'


function ActionRequired() {

    let dispatch = useDispatch()
  const location = useLocation();
  let { path, url } = useRouteMatch();
  const patientIds = location.state?.patientId;
  let history = useHistory();

    //value taken
    let [emergencylevels, setEmergencylevel] = useState();
    let [Notetodoctor, setNotetodoctor] = useState();
    let [error, setError] = useState();
    let [message, setmessage] = useState("");
    let [isSuccess, setSuccess] = useState(false);
    let [successMessage, setSuccessMessage] = useState("");
  
    let [keepUpdate, setKeepUpdate] = useState(true)
    let reduxvitalsdata = useSelector((state) => state);
    let userId = reduxvitalsdata.login.user.userId;
    let userType = reduxvitalsdata.login.user.userType;
    let vitalid;
    const [form] = Form.useForm();

    console.log("Redux vitalsdata in RpmProfile: ", reduxvitalsdata);
    let patientId = localStorage.getItem("patientId");
    useEffect(() => {
        dispatch(getpatientvitals(patientId));
        
      }, []);

    let vitalsdata = reduxvitalsdata.rpmreducer?.patientsvital && reduxvitalsdata.rpmreducer?.patientsvital?.data[0];
    let handleChangeKeepUpdate = (e) => {

        console.log(e.target.checked);
        setKeepUpdate(!keepUpdate)
    }

    useEffect(() => {
        setEmergencylevel(vitalsdata?.EmergencyLevel?vitalsdata.EmergencyLevel:"")
      }, [emergencylevels]);


    const NurseNextstep = () => {

        dispatch((Nurseactiontaken(patientId,  userId, vitalsdata.doctorId, vitalsdata?.EmergencyLevel, Notetodoctor, vitalsdata?.vitalId?vitalsdata?.vitalId:""))).then((res) => {
            console.log("nurseactiontaken API result ==> ", res);
            if (res.data.info == "Data failed to update") {
              setError("Error");
              setmessage(res.data.info);
            } else {
              setError("Success");
              setSuccess(true);
              setSuccessMessage(res.data.info);
              setmessage(res.data.info);
              // history.push({
              //   pathname:"/rpm",
              //   state: { message: "Successfully Escalated"},
              // });
            }
            // setPaymentLoading(false)
            console.log("book_slot API result ==> ", res);
          });
    }

    let onFinish = (e) => {

        //Form submission when all fields are filled..................
        NurseNextstep()
      }
      let onFinishFailed = (e) => {
        console.log(e);
      }

    let getDataFromVitals = (itemName, extension, ifEmpty) => {

        if (vitalsdata && vitalsdata[itemName]) {
          if (extension) {
            return vitalsdata[itemName] + extension
          } else {
    
            return vitalsdata[itemName]
          }
    
        }
        else if (ifEmpty) {
          return ifEmpty
        }
        else {
          return ""
        }
    
      }


    return (
        <div className='send-ambulance-container'>
            <Form
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}

            >
            <div className="ambulance-header">Assigned by Doctor</div>

            <table className='patient-details-table'>
                <tr>
                    <td>Patient Name</td>
                    <td>:</td>
                    <td>
                        <div className="patient-details-item-container">
                            <input className='name-input' type="text" name="" id="" value={getDataFromVitals("patientName")} readOnly />
                        </div>
                    </td>
                    <td></td>
                </tr>


                <tr>
                    <td>Medical Emergency Level</td>
                    <td>:</td>

                    <td>
                        <div className="patient-details-item-container" style={{ maxWidth: "fit-content" }} value={getDataFromVitals("EmergencyLevel")}>
                        <input className='name-input' type="text" name="" id="" value={getDataFromVitals("EmergencyLevel")} readOnly />
                        {/* <Form.Item
                            name="normalMin"
                            rules={[{ required: true, message: 'Select emergency level!' }]}
                            value={getDataFromVitals("EmergencyLevel")}
                            >
                            <Dropdown
                                // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                // onChange={updateTable}
                                onChange={(e) => {
                                    setEmergencylevel(e.value);
                                  }}
                                data={EmergencyLevel}
                                width={250}
                                value="Level 2"
                                placeholder="Select level"
                                isV2
                                
                            />
                            </Form.Item> */}
                        </div>
                    </td>

                    <td></td>
                </tr>

                <tr>
                    <td className='patient-details-table-red'>Action to take</td>
                    <td>:</td>
                    <td>
                        <div className="patient-details-item-container" >
                            
                        <input className='name-input' type="text" name="" id="" value={getDataFromVitals("actiontotakenbynurse")} readOnly />
                        {/* <Form.Item
                            name="actiontotaken"
                            rules={[{ required: true, message: 'Select emergency level!' }]}
                            >
                            <Dropdown
                                // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                // onChange={updateTable}
                                data={Actionstotake}
                                width={"100%"}
                                placeholder="Select action"
                                isV2
                            // value={element.Allergent}
                            />
                            </Form.Item> */}
                        </div>
                    </td>
                    <td></td>
                </tr>

                <tr>
                    <td className='patient-details-table-red'>Notes for Nurse</td>
                    <td>:</td>
                    <td>
                        <div className="patient-details-item-container address-container" >
                            <textarea rows="6" className='address-input' type="text" name="" id="" value={getDataFromVitals("notestonurse")} readOnly >
                               

                            </textarea>
                            <div className='address-options-container'>
                                <span className='item'>
                                    <div className="icon">
                                        <Radio checked={keepUpdate} onClick={handleChangeKeepUpdate} />
                                        <span>Please keep me updated on this patient</span>
                                    </div>
                                </span>


                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>

                <tr >
                    <td className='patient-details-table-breaker' colSpan={4}></td>
                </tr>

                <tr >
                    <td className='' colSpan={4}>&nbsp;</td>
                </tr>


                <tr>
                    <td style={{verticalAlign:"top",paddingTop:"30px"}}>Next steps by Nurse</td>
                    <td style={{verticalAlign:"top",paddingTop:"30px"}} >:</td>
                    <td>
                        <div className="patient-details-item-container address-container" >
                        <Form.Item
                            name="nextstep"
                            rules={[{ required: true, message: 'Select emergency level!' }]}
                            >
                            <textarea rows="6" className='address-input' type="text" name="" id=""
                             onChange={(e) => {
                                setNotetodoctor(e.target.value);
                              }} >
                            
                            </textarea>
                            </Form.Item>
                           
                        </div>
                    </td>
                    <td></td>
                </tr>





                <tr>
                    <td></td>
                    <td></td>
                    <td>

                        <div className="instruction-to-nurse-submit-container">
                        <button
                type='submit'
                className="sbt-btn"
              // onClick={savesettings}
              >SAVE</button>
                        </div>

                    </td>
                    <td></td>

                </tr>
            </table>
            <SuccessModal
          state={isSuccess}
          setState={setSuccess}
          successMessage={successMessage}
        />
            </Form>
        </div>
    )
}

export default ActionRequired